<template>
  <div>
    <el-upload
      class="avatar-uploader"
      action="#"
      :show-file-list="false"
      :http-request="upload"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
    >
      <img v-if="imageUrlProps" :src="imageUrlProps" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>

<script>
import { uploadAdmin } from '@/api/common'
export default {
  props: {
    imageUrl: {
      type: String
    },
    imageUrls: {
      type: String
    }
  },
  watch: {
    imageUrl: {
      handler: function (newVal, oldVal) {
        if (newVal != oldVal) {
          this.imageUrlProp = newVal
        }
      },
      immediate: true,
      deep: true
    },
    imageUrls: {
      handler: function (newVal, oldVal) {
        if (newVal != oldVal) {
          this.imageUrlProps = newVal
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      imageUrlProp: '',
      imageUrlProps: ''
    }
  },
  created(){
    if (this.imageShow != '') {
      this.fileList = []
      this.fileList.push({
        name: this.imageShow,
        url: this.imageShow
      })
    }
  },
  computed:{
    Authorization() {
      return  sessionStorage.getItem('token')
    }
  },
  methods: {
    async upload(file) {
      const form = new FormData()

      form.append('files', file.file)

      form.append('Authorization', this.Authorization)

      const res = await uploadAdmin(form)

      if (res.data.resultCode === 200) {
        this.imageUrlProps = res.data.data.fileLook[0]
        this.imageUrlProp = res.data.data.fileAddr[0]
        this.$emit('update:imageUrl', this.imageUrlProp)
        this.$emit('update:imageUrls', this.imageUrlProps)
      }
    },
    handleAvatarSuccess(res, file) {
      this.imageUrlProp = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {
      // console.log(file)
      const isJPG =
        file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 5
      // console.log(file.type === 'image/jpeg')
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 image/jpeg/png 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
      }
      return isJPG && isLt2M
    }
  }
}
</script>

<style scoped lang="less">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border-radius: 10px;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  box-sizing: border-box;
}
.avatar {
  width: 100px;
  height: 100px;
  // display: block;
  border-radius: 5px;
}
</style>
